// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"cb911cf4","667":"6d0c585f","688":"53754b56"}[chunkId] + ".chunk.js";
};